import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { DiscoverCatalogKey } from './discover.i18n.js';
import { DISCOVER_CATALOG } from './discover.i18n.js';

export type DiscoverMessageId = `discover:${DiscoverCatalogKey}`;

const PREFIX_LENGTH = 'discover:'.length;

/** `t()` for the stop-gap `discover:` scope (see `discover.i18n.ts`). */
export function useDiscoverT(): { t: (id: DiscoverMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: DiscoverMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as DiscoverCatalogKey;
      const raw = DISCOVER_CATALOG[locale][key] ?? DISCOVER_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
